export default __webpack_public_path__ + "static/media/nexity-regulations-en.dea98ee4.pdf";